// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M17 7H11V13H17V7Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M7 3H21V17H7V3ZM9 5V15H19V5H9Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M5 7.5V10.5H3V7.5H5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M5 12.5V15.5H3V12.5H5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M5 17.5V19H6.5V21H3V17.5H5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M11.5 19V21H8.5V19H11.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13.5 19H16.5V21H13.5V19Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-flip-to-front-filled')
export default class FlipToFrontFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'flip-to-front-filled',
    }
  }
}
